export const virtualCircuitComment =
    "\n\nBelow ---- is where you can set values that the virtual circuit will take in.";

export const whatIsAPin = `\n\nA pin is a piece of metal connected to the Arduino used to control or sense electricity.`;
